import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { UserService } from '../auth/_services';

@Injectable()
export class Api {
    constructor(private http: HttpClient) {
    }

    post<T>(url: string, data: any, options?: any): Observable<any> {
        let opt = Object.assign({}, options);
        opt.params = Object.assign(opt.data || {}, opt.params);
        opt.headers = Object.assign({ apikey: UserService.getToken() }, opt.headers);

        return this.http.post(environment.server + url, data, opt);
    }

    get<T>(url: string, params: any, options?: any): Observable<any> {
        let opt = Object.assign({}, options);
        opt.params = Object.assign(opt.data || {}, params);
        opt.headers = Object.assign({ apikey: UserService.getToken() }, opt.headers);

        return this.http.get(environment.server + url, opt);
    }
}


// WEBPACK FOOTER //
// ./src/app/_services/api.ts